import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-040dd77e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_page_card = _resolveComponent("page-card")!
  const _component_EnclosurePreview = _resolveComponent("EnclosurePreview")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_OperationalApprovalProcess = _resolveComponent("OperationalApprovalProcess")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, null, {
    main: _withCtx(() => [
      _createVNode(_component_page_card, { title: "配置详情" }, {
        "header-right": _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions, {
            column: 3,
            border: "",
            class: "content"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approveDetailKeyMap, (item, key) => {
                return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: key,
                  label: `${item.label}：`,
                  "label-align": "center"
                }, {
                  default: _withCtx(() => [
                    (key === 'environment')
                      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formatter(_ctx.approveDetail.environment), (environment, index) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: index,
                                style: {"margin":"2px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(environment), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      : (key === 'firstHeadOfBackend')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.approveDetail.firstHeadOfBackend)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.approveDetail.firstHeadOfBackend) + "(" + _toDisplayString(_ctx.approveDetail.firstHeadOfBackendCode) + ") ", 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (key === 'secondHeadOfBackend')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (_ctx.approveDetail.secondHeadOfBackend)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.approveDetail.secondHeadOfBackend) + "(" + _toDisplayString(_ctx.approveDetail.secondHeadOfBackendCode) + ") ", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(item.formatter ? item.formatter(_ctx.approveDetail[key]) : _ctx.approveDetail[key]), 1)
                            ], 64))
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128)),
              _createVNode(_component_el_descriptions_item, {
                label: "审批流程：",
                "label-align": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approvalProcessVisible = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 项目申请 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.OperationalApprovalProcessVisible = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 运维申请 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.approveDetail.enclosureList?.length)
        ? (_openBlock(), _createBlock(_component_page_card, {
            key: 0,
            title: "附件"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_EnclosurePreview, {
                enclosureList: _ctx.approveDetail.enclosureList
              }, null, 8, ["enclosureList"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_page_card, { title: "关联详情" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.relativeProjectList,
            "span-method": _ctx.arraySpanMethod,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "关联项目",
                prop: "projectName"
              }, {
                default: _withCtx(({ row }) => [
                  (row.projectName)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                  name: 'ProjectServiceManageProjectServiceList',
                  params: {
                    projectName: row.projectName,
                    serviceName: _ctx.approveDetail.serviceName,
                  }
                }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(row.projectName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "一级菜单",
                prop: "firstLevelMenu"
              }, {
                default: _withCtx(({ row }) => [
                  (row.firstLevelMenu)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                  name: 'ProjectServiceManageProjectServiceList',
                  params: {
                    projectName: row.projectName,
                    firstLevelMenu: row.firstLevelMenu,
                    serviceName: _ctx.approveDetail.serviceName,
                  }
                }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(row.firstLevelMenu), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "二级菜单",
                prop: "secondLevelMenu"
              }, {
                default: _withCtx(({ row }) => [
                  (row.secondLevelMenu)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                  name: 'ProjectServiceManageProjectServiceList',
                  params: {
                    projectName: row.projectName,
                    firstLevelMenu: row.firstLevelMenu,
                    secondLevelMenu: row.secondLevelMenu,
                    serviceName: _ctx.approveDetail.serviceName,
                  }
                }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(row.secondLevelMenu), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "span-method"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ApprovalProcess, {
        modelValue: _ctx.approvalProcessVisible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.approvalProcessVisible) = $event)),
        dataList: _ctx.processNodeList
      }, null, 8, ["modelValue", "dataList"]),
      _createVNode(_component_OperationalApprovalProcess, {
        modelValue: _ctx.OperationalApprovalProcessVisible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.OperationalApprovalProcessVisible) = $event)),
        operationDataList: _ctx.OperationalApprovalProcessList
      }, null, 8, ["modelValue", "operationDataList"])
    ]),
    _: 1
  }))
}